import Microgame from '../engine/Microgame.js';

export default class BowlingGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Bowling !`, en: `Bowling!`, es: `¡Bolos!` },
            controls: { fr: `Glisse vers l'avant pour lancer la boule`, en: `Swipe forward to throw the ball`, es: `Desliza hacia adelante para lanzar la bola` },
            objective: { fr: `Fais tomber toutes les quilles lumineuses`, en: `Knock down all glowing pins`, es: `Derriba todos los bolos brillantes` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><circle cx="12" cy="18" r="4"/><path d="M8 4l2 8M16 4l-2 8"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/></svg>`,
            actions: [
                { type: 'wait', duration: 700 },
                { type: 'tap', x: 50, y: 86, duration: 140 },
                { type: 'wait', duration: 520 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.ball = null;
        this.pins = [];
        this.state = 'aiming'; // aiming, rolling, result
        const speedMult = engine.speedMultiplier || 1.0;
        this.moveSpeed = 200 * speedMult; // Scale the movement speed of the ball with difficulty so it sweeps fast enough at higher levels
        this.direction = Math.random() > 0.5 ? 1 : -1;
        this.ballX = this.isPlayback ? 50 : 25 + Math.random() * 50; // Random starting position between 25% and 75%

        // Give plenty of time to aim
        const adjustedSpeed = 1 + (speedMult - 1) * (1.2 / 3);
        this.duration = 4500 * (speedMult / adjustedSpeed);
    }

    setup() {
        this.engine.ui.instruction.textContent = "STRIKE!";

        // Lane (Visual)
        const lane = document.createElement('div');
        lane.style.position = 'absolute';
        lane.style.width = '60%';
        lane.style.height = '100%';
        lane.style.left = '20%';
        lane.style.background = 'rgba(255,255,255,0.05)';
        lane.style.borderLeft = `2px solid ${this.secondaryColor}`;
        lane.style.borderRight = `2px solid ${this.secondaryColor}`;
        this.container.appendChild(lane);

        // Pins (Secondary)
        const pinOffsets = [
            { x: 0, y: 0 },
            { x: -15, y: -15 }, { x: 15, y: -15 },
            { x: -30, y: -30 }, { x: 0, y: -30 }, { x: 30, y: -30 }
        ];

        const pinsContainer = document.createElement('div');
        pinsContainer.style.position = 'absolute';
        pinsContainer.style.top = '15%';
        pinsContainer.style.left = '50%';
        this.container.appendChild(pinsContainer);

        pinOffsets.forEach(off => {
            const pin = document.createElement('div');
            pin.style.position = 'absolute';
            pin.style.width = '10px';
            pin.style.height = '10px';
            pin.style.background = this.secondaryColor;
            pin.style.borderRadius = '50%';
            pin.style.left = `${off.x}px`;
            pin.style.top = `${off.y}px`;
            pin.style.transform = 'translate(-50%, -50%)';
            pin.style.boxShadow = `0 0 5px ${this.secondaryColor}`;
            pin.dataset.hit = 'false';
            pinsContainer.appendChild(pin);
            this.pins.push(pin);
        });

        // Ball (Primary)
        this.ball = document.createElement('div');
        this.ball.style.position = 'absolute';
        this.ball.style.width = '30px';
        this.ball.style.height = '30px';
        this.ball.style.background = this.primaryColor;
        this.ball.style.borderRadius = '50%';
        this.ball.style.bottom = '10%';
        this.ball.style.left = '50%';
        this.ball.style.transform = 'translate(-50%, 50%)';
        this.ball.style.boxShadow = `0 0 15px ${this.primaryColor}`;
        this.container.appendChild(this.ball);

        this.onDown = this.onDown.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onDown);
    }

    update(dt) {
        if (!this.active || this.won) return;

        if (this.state === 'aiming') {
            this.ballX += this.moveSpeed * this.direction * (dt / 1000) / (this.container.clientWidth / 100);

            if (this.ballX > 75) {
                this.ballX = 75;
                this.direction = -1;
            } else if (this.ballX < 25) {
                this.ballX = 25;
                this.direction = 1;
            }
            this.ball.style.left = `${this.ballX}%`;
        } else if (this.state === 'rolling') {
            // Move up
            const currentBottom = parseFloat(this.ball.style.bottom) || 10;
            const newBottom = currentBottom + 100 * (dt / 1000);
            this.ball.style.bottom = `${newBottom}%`;

            // Scale down
            const scale = 1 - (newBottom / 200);
            this.ball.style.transform = `translate(-50%, 50%) scale(${scale})`;

            // Check collision with pins area
            if (newBottom > 80) {
                if (Math.abs(this.ballX - 50) < 10) {
                    this.strike();
                    this.state = 'result';
                } else if (newBottom > 110) {
                    // Missed and went off screen
                    this.lose();
                    this.state = 'result';
                }
            }
        }
    }

    strike() {
        // Don't call win() immediately
        this.pins.forEach(pin => {
            pin.style.transition = 'transform 0.5s, opacity 0.5s';
            pin.style.transform += ` translate(${Math.random() * 100 - 50}px, ${Math.random() * 100 - 50}px)`;
            pin.style.opacity = '0';
        });

        // Win after delay
        setTimeout(() => {
            if (this.active) this.win();
        }, 500);
    }

    onDown() {
        if (!this.active || this.state !== 'aiming') return;
        this.state = 'rolling';
        this.hideTimer = true; // Stop the visual timer since we just have to wait for the animation
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
    }
}
